import { useEffect, useState } from 'react';
import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';

export const useLogViewMarket = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    if (isLogged) return;

    const result = logMarketAnalytics({
      name: 'VIEW_MARKET',
      analytics: {
        RESTORE: 0,
        REALTIME_RANKING_COUNT: 0,
        LANDING_FROM: null,
      },
    });
    setIsLogged(result);
  }, [logMarketAnalytics, isLogged]);
};
